import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { isEmpty } from 'lodash';
import Breadcrumb from 'components/consumer/consumer-breadcrumb';
import usePDPBreadcrumbs from 'data-hooks/usePDPBreadcrumbs';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
const PDPBreadCrumbsInner = () => {
  const $ = _c(2);
  const breadCrumbData = usePDPBreadcrumbs();
  let t0;
  if ($[0] !== breadCrumbData) {
    t0 = !isEmpty(breadCrumbData) ? <><MobileAndTabletOnly><div className="lg:hidden"><Breadcrumb color="dark" forPage="PDPMobile" config={{
            items: breadCrumbData.data
          }} /></div></MobileAndTabletOnly><DesktopOnly><div className="max-[1023px]:hidden"><Breadcrumb color="light" forPage="PDP" config={{
            items: breadCrumbData.data
          }} /></div></DesktopOnly></> : null;
    $[0] = breadCrumbData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const PDPBreadCrumbs = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPBreadCrumbsInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPBreadCrumbs;